import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import React from 'react';
import QuantityCardItem from './QuantityCardItem';
import FieldWrapper, { FieldWrapperProps } from '../../../Structure/FieldWrapper/FieldWrapper';
import { FormFieldProps } from 'lib/forms';
import { useTheme } from 'lib/context/ThemeContext';
import { FormFieldsTheme } from '../../FormFields.Theme';
import classNames from 'classnames';
import { RichTextWrapper } from 'src/helpers/RichTextWrapper';

export {
  getButtonGroupInitialValue as getInitialValue,
  getButtonGroupValidationSchema as getValidationSchema,
} from '../ButtonGroup.helpers';

type QuantityCardItem = Feature.EnterpriseWeb.Enterprise.Forms.Elements.QuantityCardItem;

export type QuantityCardProps = Feature.EnterpriseWeb.Enterprise.Forms.Fields.QuantityCard & {
  fields: {
    datasource: {
      children: Array<QuantityCardItem>;
    };
  };
} & FormFieldProps;

const QuantityCard = (props: QuantityCardProps) => {
  const { themeData } = useTheme(FormFieldsTheme);
  const { fields } = props;

  if (!fields) {
    return <></>;
  }

  return (
    <FieldWrapper {...(props as FieldWrapperProps)} isArrayField={true}>
      {props.fields?.questionLabel && (
        <label
          className={classNames(themeData.classes.quantityCard.questionLabel)}
          htmlFor={props.name}
        >
          {props.fields.questionLabel.value}
        </label>
      )}
      {props.fields?.questionSublabel && (
        <div className={classNames(themeData.classes.quantityCard.questionSublabel)}>
          <RichTextWrapper field={{ value: props.fields?.questionSublabel.value }} classes="" />
        </div>
      )}
      <div className="grid grid-cols-2 gap-s md:grid-cols-12">
        {fields.datasource?.children.map((quantityCardItem: QuantityCardItem, index: number) => {
          return (
            <div className="col-span-2 md:col-span-4" key={index}>
              <QuantityCardItem key={index} {...props} {...quantityCardItem} />
            </div>
          );
        })}
      </div>
    </FieldWrapper>
  );
};

export default QuantityCard;
